import { useT } from "../../../core/i18n";
import React, { useState } from "react";
import Table from "../../../core/common/dataTable/index";
import {
  getEmployeesVerification,
  getDocument,
  employeesVerificationUpdate,
} from "../../../core/data/redux/employeesVerificationSlice";
import { useDispatch, useSelector } from "react-redux";

interface EmployeesVerificationTableProps {
  userId?: number;
  type: string;
  setItem: (item: any) => void;
}

const FaceVerificationTable = (props: EmployeesVerificationTableProps) => {
  const { t } = useT();
  const { type, setItem } = props;
  const dispatch = useDispatch();
  const employeesVerificationState = useSelector(
    (state: any) => state.employeesVerificationState
  );
  const [dataList, setDataList] = React.useState<any[]>([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });

  const fetchRecords = () => {
    dispatch(
      getEmployeesVerification({
        page: pagination.current,
        limit: pagination.pageSize,
        is_verified: type,
      })
    );
  };

  const getDocumentUrl = async (record: any) => {
    setItem(record);
    await dispatch(getDocument({ id: record.id }));
  };

  React.useEffect(() => {
    fetchRecords();
  }, [type]);

  React.useEffect(() => {
    if (
      employeesVerificationState.loading === "fulfilled" &&
      employeesVerificationState.action === "update"
    ) {
      fetchRecords();
    } else if (
      employeesVerificationState.loading === "fulfilled" &&
      employeesVerificationState.action === "list"
    ) {
      const result = employeesVerificationState?.data?.data || null;

      if (result.data && result.data.length > 0) {
        const employees = result?.data || [];
        setDataList(employees);
        setPagination({
          ...pagination,
          total: result.total || employees.length,
          current: result.page || 1,
          pageSize: result.limit || 10,
        });
      } else {
        setDataList([]);
      }
    }
  }, [employeesVerificationState.loading]);

  const columns = [
    {
      title: t("sr_no"),
      dataIndex: "id",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <div>
          {pagination.current
            ? index +
              pagination.current * pagination.pageSize -
              pagination.pageSize +
              1
            : index + 1}
        </div>
      ),
    },
    {
      title: t("employee_name"),
      dataIndex: "employee",
      render: (employee: any) => employee?.details?.firstname || "",
    },
    {
      title: t("emp_id"),
      dataIndex: "empId",
      render: (text: any, record: any) =>
        record?.employee?.details?.empId ? parseInt(record.employee.details.empId, 10) : "",
    },
    {
      title: t("email"),
      dataIndex: "email",
      render: (text: any, record: any) =>
        record?.employee?.details?.email || "",
    },
    {
      title: t("phone"),
      dataIndex: "phone",
      render: (text: any, record: any) =>
        record?.employee?.details?.phone || "",
    },
    {
      title: t("wing"),
      dataIndex: "employee",
      render: (employee: any) =>
        employee?.details?.sap_department_designation_wings?.wing_name ? `${employee?.details?.sap_department_designation_wings?.wing_name}` : "",
    },
    {
      title: t("department"),
      dataIndex: "employee",
      render: (employee: any) =>
        employee?.details?.sap_department_designation_wings?.department_name ? `${employee?.details?.sap_department_designation_wings?.department_name}` : "",
    },
    {
      title: t("designation"),
      dataIndex: "employee",
      render: (employee: any) =>
        employee?.details?.sap_department_designation_wings?.designation_name ? `${employee?.details?.sap_department_designation_wings?.designation_name}` : "",
    },
    {
      title: t("is_verified"),
      dataIndex: "is_verified",
      render: (is_verified: any) => {
        const badgeClass =
          is_verified === "VERIFIED"
            ? "badge-success"
            : is_verified === "REJECTED"
            ? "badge-danger"
            : "badge-info";
        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            {is_verified}
          </span>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: 100,
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <button
            className="btn btn-primary btn-sm"
            data-bs-toggle="modal"
            data-inert={true}
            data-bs-target="#verify-doc"
            onClick={() => getDocumentUrl(record)}
          >
            <i className="ti ti-eye me-2" />
            View
          </button>
        </div>
      ),
    },
  ];

  const handlePagination = (pagination: any) => {
    setPagination({
      current: pagination.page,
      pageSize: pagination.pageSize,
      total: pagination.total || 10,
    });
    fetchRecords();
  };
  return (
    <div>
      <div className="card">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
          <h4 className="mb-4 mt-3">{t("face_data_verification_list")}</h4>
        </div>
        <div className="card-body p-0 py-3">
          <Table
            columns={columns}
            dataSource={dataList}
            Selection={false}
            paginationConfig={pagination}
            handlePagination={handlePagination}
            loading={employeesVerificationState.loading === "pending"}
          />
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-md-12">
          <div className="datatable-paginate mt-4" />
        </div>
      </div>
    </div>
  );
};

export default FaceVerificationTable;
